import React from 'react';
import { useQuery } from '@apollo/client';

import {
    shippingGroup_shippingGroup_items_attribute_options,
    shippingGroup,
} from '../../queries/__generated__/shippingGroup';
import { shippingGroup as shippingGroupQuery } from '../../queries/shippingGroup.graphql';

import classes from './Main.scss';

type MainProps = React.PropsWithChildren;

type MainContextInitialProps = {
    shippingGroupList: shippingGroup_shippingGroup_items_attribute_options[];
};

export const MainContext = React.createContext<MainContextInitialProps>({ shippingGroupList: [] });

export const MainProvider: React.FC<MainProps> = React.memo((props) => {
    /**
     * Get meta data of Shipping Groups
     */
    // Shipping groups are not crawl content — fetch after hydrate to cut SSR fan-out.
    const { data: dataShippingGroup } = useQuery<shippingGroup>(shippingGroupQuery, {
        ssr: false,
    });

    // Always provide an array — with ssr:false this is undefined during SSR and
    // product pages call shippingGroupList.find(...), which would 500 the reload.
    const shippingGroupList: shippingGroup_shippingGroup_items_attribute_options[] =
        dataShippingGroup?.shippingGroup?.items?.[0]?.attribute_options ?? [];

    return (
        <MainContext.Provider value={{ shippingGroupList }}>
            <main className={classes.root}>{props.children}</main>
        </MainContext.Provider>
    );
});
